import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"

export default function ImageWithText({
    global,
    pathPrefix,
    customClass = "",
    content,
    buttonTitle,
    buttonLink,
    post
}) {

    return (
        post.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                {post?.map((post, index) => (
                    <Row key={index}>
                        <Col md={6}>
                            {post?.content ?
                                <div className="post-content" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                : ""}
                            {post?.button_link && post?.button_title && (
                                <div>
                                    <Link href={`${post?.button_link}`}>
                                        <a className="primaryBtn no-arrow">
                                            {post?.button_title}
                                        </a>
                                    </Link>
                                </div>)}
                        </Col>
                        <Col md={6}>
                            <SourceFlowImage
                                src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                size="500x500"
                                alt={post?.title}
                                className="card-img"
                            />
                        </Col>
                    </Row>
                ))}
            </section>
        )
    )
}